export default "* Hvilke materialer tror I instrumenter var lavet af i jægerstenalderen?\n* Hvad brugte man musik og dans til i jægerstenalderen?";